module.exports = __webpack_public_path__ + "img/signContract.473f4d3a.svg";